const CheckCircleIcon = ( { className } ) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
				 className={className} style={{ flexShrink: 0}}>
			<rect width="24" height="24" rx="12" fill="#85C553"/>
			<path d="M17.3332 8L9.99984 15.3333L6.6665 12" stroke="white" strokeWidth="1.5" strokeLinecap="round"
						strokeLinejoin="round"/>
		</svg>
	);
};

export default CheckCircleIcon;
